'use client'

import MainNav from '@/app/components/MainNav'
import TSPProjector from '@/app/components/calculators/TSPProjector'

export default function TSPProjectorPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-5xl px-6">
        <TSPProjector />
      </div>
    </div>
  )
}
